import React from 'react';
import css from './css.module.less';
import {
  SizeFittingTable,
  Button, // ModalFooter
  /// Form,
} from 'src/components/Antd';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { EnumTablePosition } from 'src/types/common/common';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import ProductSelection from 'src/constrains/ProductSelectionNoPagination/GeneralSalesChannelProductSelection';
import { Icon } from '@/src/tools/icon';
import { TableNumberInput } from 'src/components/EditableTable/TableForm1';
import { isNumber } from 'src/tools/helper';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const NumberInput = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { value, onChange, disabled } = props;
  const hasError = React.useMemo(() => {
    if (!isNumber(value)) {
      return true;
    }
    if (value < 1) {
      return true;
    }
    return false;
  }, [value]);
  return (
    <TableNumberInput
      containerProps={{ disabled }}
      //disabled={disabled}
      value={value}
      onChange={onChange}
      error={hasError}
      label={value}
      itemProps={{
        min: 1,
        help: getI18n('voucher.storeVoucherList.minHelp'),
        wrapperClassName: !hasError ? css.test : '',
        // formProps: {
        //   status: null,
        //   className,
        // },
      }}
    />
  );
};
const parentUuidKey = 'parentUuid';
const addParentUuid = (products) => {
  return products.map((i) => {
    const { children, uuid } = i;
    if (children) {
      const _children = children.map((child) => {
        return { [parentUuidKey]: uuid, ...child };
      });
      return { ...i, children: _children };
    }
    return i;
  });
};

// const preProcessProduct = (products) => {
//   return products.map((i) => {
//     return { ...i, children: null };
//   });
// };

const ProductTable = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    value,
    onChange,
    id,
    tableId,
    salesChannelUuid,
    disabledProducts,
    disabled,
  } = props;
  const col = (onDelete, onChange, disabled) => {
    return [
      {
        title: getI18n('general.productName'),
        dataIndex: 'productName',
        default: true,
        sorter: (a, b) => {
          const name1 = a.productName || '';
          const name2 = b.productName || '';
          const n1 = name1.toLowerCase();
          const n2 = name2.toLowerCase();
          if (n1 > n2) return 1;
          if (n2 > n1) return -1;
          return 0;
        },

        //className: css.expandRow,
        key: 'productName',
        childGenerate: (text, record) => {
          // console.log('record', record);
          const { thumbnailUrl, productName } = record;
          return (
            <div className={css.productNameContainer}>
              {thumbnailUrl && (
                <img
                  style={{
                    marginRight: 12,
                  }}
                  width={40}
                  height={40}
                  key={thumbnailUrl}
                  src={thumbnailUrl}
                  alt={thumbnailUrl}
                />
              )}
              <NoWrapContainer>
                <GlobalTooltip title={productName || '-'}>
                  <div className={css.text}>{productName || '-'}</div>
                </GlobalTooltip>
              </NoWrapContainer>
            </div>
          );
        },

        minWidth: 260,
      },
      {
        title: getI18n('general.sKU'),
        dataIndex: 'sku',
        default: true,
        sorter: (a, b) => {
          const name1 = a.productName || '';
          const name2 = b.productName || '';
          const n1 = name1.toLowerCase();
          const n2 = name2.toLowerCase();
          if (n1 > n2) return 1;
          if (n2 > n1) return -1;
          return 0;
        },

        key: 'sku',

        minWidth: 166,
      },
      {
        title: getI18n('general.remarks'),
        dataIndex: 'remarks',
        default: true,
        key: 'remarks',
        minWidth: 200,
      },

      {
        title: getI18n('general.quantity'),
        default: true,
        key: 'Quantity',
        width: 210,
        childGenerate: (a, record, index) => {
          const { uuid, quantity } = record;
          const name = uuid + id;
          return (
            <NumberInput
              value={quantity}
              onChange={(e) => {
                onChange(record, e);
              }}
              name={name}
              disabled={disabled}
            />
          );
        },
      },
      {
        titleGenerate: () =>
          getI18n(
            'general.advancedFilters.commonStoreProductsWithTable.actions',
          ),
        position: EnumTablePosition.mid,
        key: 'Actions',
        default: true,
        childGenerate: (url, record, index) => {
          return (
            <Actions
              disabled={disabled}
              onDelete={() => {
                if (onDelete && !disabled) {
                  onDelete(record, index);
                }
              }}
            />
          );
        },
        width: 190,
      },
    ];
  };
  const [products, setProducts] = React.useState(value || []);
  const isNoData = (products || []).length === 0;
  const [visible, setVisible] = React.useState(false);
  const processProduct = React.useMemo(() => {
    return addParentUuid(products || []);
  }, [products]);

  const tableDisplay = React.useMemo(() => {
    return processProduct.reduce((pre, now) => {
      const { children } = now;
      if ((children || []).length > 0) {
        return [...pre, ...children];
      }
      return [...pre, now];
    }, []);
  }, [processProduct]);
  React.useEffect(() => {
    if (value !== products) {
      const _v = value || [];
      setProducts(_v);
    }
  }, [value]);

  const handleOnCancel = () => {
    setVisible(false);
  };

  const handleOnChange = (products) => {
    if (onChange) {
      onChange(products);
    }
    // setProducts(products);
  };
  const handleOnDelete = (record, index) => {
    const { child, uuid } = record;
    const parentUuid = record[parentUuidKey];
    if (!child) {
      const p = products.filter((i) => {
        return i.uuid !== uuid;
      });
      setProducts(p);
      handleOnChange(p);
    } else {
      const p = products.reduce((pre, now) => {
        if (now.uuid === parentUuid) {
          const { children } = now;
          const _children = (children || []).filter((i) => i.uuid !== uuid);
          const shouldKeep = _children.length > 0; //没有孩子了 直接清空
          if (shouldKeep) {
            return [...pre, { ...now, children: _children }];
          } else {
            return pre;
          }
          //
        } else {
          return [...pre, now];
        }
      }, []);
      setProducts(p);
      handleOnChange(p);
    }
  };
  const handleOnDeleteAll = () => {
    setProducts([]);
    handleOnChange([]);
  };
  const handleOnEdit = () => {
    setVisible(true);
  };
  const handleOnOk = (p) => {
    const _p1 = addParentUuid(p);
    const preQuantity = processProduct.reduce((pre, now) => {
      const { quantity, uuid, children } = now;
      if ((children || []).length > 0) {
        const _c = children.reduce((cPre, child) => {
          const parentUuid = child[parentUuidKey];
          const { uuid, quantity } = child;
          return { ...cPre, [`${parentUuid}+++${uuid}`]: quantity };
        }, {});
        return { ...pre, ..._c };
      } else {
        return { ...pre, [uuid]: quantity };
      }
    }, {});
    const _p = _p1.map((i) => {
      const { uuid, children } = i;
      if ((children || []).length > 0) {
        const _children = children.map((child) => {
          const parentUuid = child[parentUuidKey];
          const { uuid } = child;
          const __key = `${parentUuid}+++${uuid}`;
          const quantity = preQuantity[__key] || 1;
          return { ...child, quantity };
        });
        return { ...i, quantity: null, children: _children };
      }
      const quantity = preQuantity[uuid] || 1;
      return { ...i, quantity };
    });
    //   console.log('_p', _p);
    setProducts(_p);
    handleOnChange(_p);
    handleOnCancel();
  };
  const handleOnQuantityChange = (record, quantity) => {
    const { child } = record;
    if (child) {
      const { uuid } = record;
      const parentUuid = record[parentUuidKey];
      const newP = processProduct.map((i) => {
        const { uuid: pUuid, children } = i;
        if (pUuid === parentUuid) {
          const _children = (children || []).map((child) => {
            const { uuid: cUuid } = child;
            if (cUuid === uuid) {
              return { ...child, quantity };
            }
            return child;
          });
          return { ...i, children: _children };
        }
        return i;
      });
      setProducts(newP);
      handleOnChange(newP);
    } else {
      const { uuid } = record;
      const newP = processProduct.map((i) => {
        const { uuid: sUuid } = i;
        if (sUuid === uuid) {
          return { ...i, quantity };
        }
        return i;
      });
      setProducts(newP);
      handleOnChange(newP);
    }
    // const _p = [...products];
    // _p[index].quantity = quantity;
  };
  return (
    <div className={css.productTableContainer} id={id}>
      {visible && (
        <ProductSelection
          disabledProducts={disabledProducts}
          selectedProducts={products}
          onCancel={handleOnCancel}
          visible={visible}
          salesChannelUuid={salesChannelUuid}
          onOk={handleOnOk}
          uniqueSku
          canSelectChildren
        />
      )}
      <SizeFittingTable
        id={tableId || 'SalesChannelProductTable' + id}
        dataSource={tableDisplay}
        pagination={false}
        columns={col(handleOnDelete, handleOnQuantityChange, disabled)}
        rowKey={'uuid'}
        scroll={{ x: 'max-content', y: 600 }}
        expandable={{
          //indentSize: 16,
          expandIcon: ({ expanded, onExpand, record }) => {
            if (record.children) {
              return expanded ? (
                <Icon
                  onClick={(e) => onExpand(record, e)}
                  className={css.expandIcon}
                  type='iconleft'
                  style={{ transform: 'rotate(270deg)' }}
                />
              ) : (
                <Icon
                  type='iconleft'
                  onClick={(e) => onExpand(record, e)}
                  className={css.expandIcon}
                  style={{ transform: 'rotate(180deg)' }}
                />
              );
            }
            return null;
          },
        }}
      />
      <div className={css.btnsContainer}>
        <Button
          className={css.addBtn}
          type='primary'
          onClick={handleOnEdit}
          disabled={disabled}>
          {getI18n('general.selectProduct')}
        </Button>
        {!isNoData && (
          <Button
            className={`${css.deleteBtn} ${disabled ? css.disabled : ''}`}
            onClick={handleOnDeleteAll}
            disabled={disabled}>
            {getI18n('general.deleteall')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ProductTable;
